/**
 * Normalize email input before sending to Supabase auth or edge functions.
 * Trims whitespace (mobile autocomplete often appends a space) and lowercases
 * so server-side lookups don't miss due to case differences.
 */
export const normalizeEmail = (raw: string): string => raw.trim().toLowerCase();

/**
 * Map known Supabase / GoTrue auth errors to user-friendly NL messages.
 * Returns the original message as fallback.
 */
export const friendlyAuthError = (rawMessage: string | undefined | null): string => {
  const msg = (rawMessage ?? "").toLowerCase();
  if (!msg) return "Er ging iets mis. Probeer het opnieuw.";

  if (msg.includes("unable to validate email") || msg.includes("invalid format") || msg.includes("email_address_invalid")) {
    return "Dit e-mailadres lijkt ongeldig. Controleer op spaties of typefouten.";
  }
  if (msg.includes("user already registered") || msg.includes("already been registered") || msg.includes("already registered")) {
    return "Dit e-mailadres heeft al een account. Probeer in te loggen.";
  }
  if (msg.includes("password should be at least") || msg.includes("password is too short")) {
    return "Wachtwoord is te kort (minimaal 8 tekens).";
  }
  if (msg.includes("pwned") || msg.includes("compromised")) {
    return "Dit wachtwoord komt voor in een datalek. Kies een ander wachtwoord.";
  }
  if (msg.includes("email not confirmed")) {
    return "Je e-mail is nog niet bevestigd. Check je inbox (en spam).";
  }
  if (msg.includes("invalid login credentials")) {
    return "E-mailadres of wachtwoord klopt niet.";
  }
  if (msg.includes("rate limit") || msg.includes("too many")) {
    return "Te veel pogingen. Wacht even en probeer het opnieuw.";
  }
  if (msg.includes("signups not allowed") || msg.includes("signup disabled")) {
    return "Aanmelden is tijdelijk uitgeschakeld. Probeer het later opnieuw.";
  }
  return rawMessage ?? "Er ging iets mis. Probeer het opnieuw.";
};
